import { CloseIcon } from "@chakra-ui/icons";
import { Box } from "@chakra-ui/layout";
import React from "react";

interface ToastProps {
  onClose: () => void;
  description: string;
  status: "success" | "error" | "info" | "warning";
}

const getColorByStatus = {
  success: { borderColor: "brand.green", textColor: "white" },
  error: { borderColor: "brand.red", textColor: "white" },
  info: { borderColor: "brand.blue", textColor: "white" },
  warning: { borderColor: "brand.pink", textColor: "white" },
};

export const Toast: React.FC<ToastProps> = ({
  description,
  onClose,
  status,
}) => {
  const color = getColorByStatus[status || "success"];

  return (
    <Box
      w="311px"
      p="24px"
      border="1px"
      bg={color.borderColor}
      fontWeight="bold"
      fontSize="14px"
      borderColor={color.borderColor ?? color}
      borderRadius="3px"
      color={color.textColor ?? color}
      position="relative"
      shadow="outer"
    >
      {description}
      <Box position="absolute" top="10px" right="12px">
        <CloseIcon onClick={onClose} boxSize="12px" />
      </Box>
    </Box>
  );
};
